/* eslint-disable react-hooks/exhaustive-deps */

import { SessionContextProvider } from "../../contexts/SessionContext";
import { AppProviders } from "../../contexts/AppProviders";
import { SidebarNavigationProvider } from "../../contexts/SidebarNavigationContext";
import { LoggedUserContent } from "./LoggedUserContent";

/**
 * @description Componente que fornece o contexto de sessão para a aplicação
 * @returns JSX.Element
 */
export default function LoggedUser() {
  return (
    <SessionContextProvider>
      <SidebarNavigationProvider>
        <AppProviders>
          <LoggedUserContent />
        </AppProviders>
      </SidebarNavigationProvider>
    </SessionContextProvider>
  );
}
